import { Outlet } from "react-router-dom";
import MngProductNavigation from "./MngProductNavigation";
import classes from "../MngCommon.module.css";

function MngProductRootLayout() {
  return (
    <>
      <div className={classes.admin_container}>
        <MngProductNavigation />
        <Outlet />
      </div>
    </>
  );
}

export default MngProductRootLayout;
